import { HStack, Icon, VStack } from "@/shared/ui/primitives";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

export const DifferentiationSection = () => {
	const { t } = useTranslation();

	const comparisonItems = [1, 2, 3, 4, 5];

	return (
		<VStack className="w-full gap-[28px]">
			<h2 className="text-[1.5rem] md:text-[2.25rem] text-ct-strong font-semibold text-center">
				{t("home.differentiation.title")}
			</h2>

			{/* 데스크톱: 테이블 레이아웃 */}
			<VStack className="w-full gap-[16px] hidden md:flex">
				{/* 헤더 */}
				<HStack className="w-full gap-[16px]">
					<div className="flex-1 w-full p-[16px] rounded-[10px] bg-bg-regular flex items-center justify-center">
						<span className="text-lg text-ct-strong font-semibold">
							{t("home.differentiation.header.erp")}
						</span>
					</div>
					<div className="flex-1 w-full p-[16px] rounded-[10px] bg-bg-regular flex items-center justify-center">
						<span className="text-lg text-ct-regular font-semibold">
							{t("home.differentiation.header.generic")}
						</span>
					</div>
					<div className="flex-1 w-full p-[16px] rounded-[10px] bg-pm-strong flex items-center justify-center">
						<span className="text-lg text-ct-elevated font-semibold">
							{t("home.differentiation.header.inflect")}
						</span>
					</div>
				</HStack>

				{/* 비교 항목들 */}
				{comparisonItems.map((item, index) => (
					<motion.div
						key={index}
						className="w-full"
						initial={{ opacity: 0, x: -20 }}
						whileInView={{ opacity: 1, x: 0 }}
						viewport={{ once: true }}
						transition={{ delay: index * 0.1, duration: 0.5 }}
					>
						<HStack className="w-full gap-[16px]">
							<div className="flex-1 w-full p-[16px] rounded-[10px] bg-bg-weak flex items-center justify-center">
								<span className="text-md text-ct-regular font-medium">
									{t(`home.differentiation.item${item}.label`)}
								</span>
							</div>
							<div className="flex-1 w-full p-[16px] rounded-[10px] bg-bg-weak flex items-center justify-center">
								<span className="text-md text-ct-regular">
									{t(`home.differentiation.item${item}.others`)}
								</span>
							</div>
							<div className="flex-1 w-full p-[16px] rounded-[10px] bg-bg-weak flex items-center justify-center">
								<HStack className="gap-[10px]">
									<Icon name="Check" width={20} height={20} className="text-pm-strong" />
									<span className="text-md text-ct-strong">
										{t(`home.differentiation.item${item}.inflect`)}
									</span>
								</HStack>
							</div>
						</HStack>
					</motion.div>
				))}
			</VStack>

			{/* 모바일: 테이블 레이아웃 */}
			<div className="w-full md:hidden rounded-[16px] overflow-hidden">
				{/* 헤더 */}
				<div className="flex w-full">
					<div className="w-1/4 shrink-0 p-[10px] bg-bg-regular flex items-center justify-center">
						<span className="text-xs text-ct-strong font-semibold text-center break-keep">
							{t("home.differentiation.header.erp")}
						</span>
					</div>
					<div className="w-1/4 shrink-0 p-[10px] bg-bg-regular flex items-center justify-center rounded-tr-[12px]">
						<span className="text-xs text-ct-regular font-semibold text-center break-keep">
							{t("home.differentiation.header.generic")}
						</span>
					</div>
					<div className="w-1/2 shrink-0 p-[10px] bg-pm-strong flex items-center justify-center rounded-t-[12px]">
						<span className="text-xs text-ct-elevated font-semibold">Inflect</span>
					</div>
				</div>
				{/* 행 */}
				{comparisonItems.map((item, index) => (
					<motion.div
						key={index}
						className={`flex w-full ${index % 2 === 0 ? "bg-bg-weak" : "bg-bg-regular/50"}`}
						initial={{ opacity: 0 }}
						whileInView={{ opacity: 1 }}
						viewport={{ once: true }}
						transition={{ delay: index * 0.08, duration: 0.4 }}
					>
						<div className="w-1/4 shrink-0 p-[10px] flex items-center justify-center">
							<span className="text-xs text-ct-regular text-center break-keep">
								{t(`home.differentiation.item${item}.label`)}
							</span>
						</div>
						<div className="w-1/4 shrink-0 p-[10px] flex items-center justify-center">
							<span className="text-xs text-ct-weak text-center break-keep">
								{t(`home.differentiation.item${item}.others`)}
							</span>
						</div>
						<div className="w-1/2 shrink-0 p-[10px] flex items-center justify-center">
							<HStack className="gap-[4px]">
								<Icon name="Check" width={14} height={14} className="text-pm-strong shrink-0" />
								<span className="text-xs text-ct-strong font-medium text-center break-keep">
									{t(`home.differentiation.item${item}.inflect`)}
								</span>
							</HStack>
						</div>
					</motion.div>
				))}
			</div>
		</VStack>
	);
};
